module.exports = __webpack_public_path__ + "static/img/JoshGiddey.5b5f662.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JoshGiddey.jpg
// module id = TJve
// module chunks = 0